import * as React from "react";
const SvgLogoWashmasterIcon = (props) => /* @__PURE__ */ React.createElement("svg", {
	id: "Ebene_1",
	"data-name": "Ebene 1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 255.12 280.76",
	...props
}, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}"), /* @__PURE__ */ React.createElement("clipPath", {
	id: "clip-path",
	transform: "translate(-14.54 -14.43)"
}, /* @__PURE__ */ React.createElement("rect", {
	className: "cls-1",
	y: .02,
	width: 283.44,
	height: 311.76
}))), /* @__PURE__ */ React.createElement("g", { className: "cls-2" }, /* @__PURE__ */ React.createElement("path", {
	d: "M119.77,157h0a22.31,22.31,0,0,0,6.54,15.78,22.13,22.13,0,0,0,7.24,4.84,22.33,22.33,0,0,0,17.09,0,22.35,22.35,0,0,0,12.08-12.08A22.32,22.32,0,1,0,119.77,157Zm-15.31,0h0a37.66,37.66,0,1,1,2.87,14.4,37.64,37.64,0,0,1-2.87-14.4",
	transform: "translate(-14.54 -14.43)"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M249.11,236.06H79V77.89H205.24V205.45H189.93V93.2H94.26V220.76H239.81A147.17,147.17,0,0,0,228.06,73l-.19-.28-.22-.26-.22-.26-.24-.24-.24-.24-.26-.22-.26-.22-.28-.2a147.23,147.23,0,0,0-168-.12l-.28.19-.26.22-.26.22-.24.24-.25.24-.21.27-.22.26-.2.28a147.22,147.22,0,0,0,0,168.14l.2.28.22.26.21.26.25.24.24.24.26.22.26.22.28.2a147.26,147.26,0,0,0,147.11,12v16.77A162.5,162.5,0,0,1,48.16,254.67l-.53-.37-.49-.42-.5-.42-.45-.45-.46-.46-.42-.49-.42-.5-.37-.52a162.51,162.51,0,0,1,0-188.12l.37-.53.42-.49.42-.49.46-.46.45-.46.5-.41.49-.42.53-.37a162.54,162.54,0,0,1,188,.13l.52.38.5.41.49.42.45.46.46.45.42.5.41.49.38.53a162.48,162.48,0,0,1,9.34,173Z",
	transform: "translate(-14.54 -14.43)"
})));
export default SvgLogoWashmasterIcon;
